function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
function openLink(event, summary) {
  console.log("link exists", event);
  window.location.href = summary.dataset.link;
}
// mouse leave closes mega Menu
document.querySelector("sticky-header")?.addEventListener("mouseleave", () => {
  document.querySelectorAll("details[open].mega-menu").forEach((ele) => {
    ele.removeAttribute("open");
  });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  if (summary.closest("details.mega-menu")) {
    if (summary.dataset.link) {
      summary.addEventListener("mousedown", function (event) {
        openLink(event, summary);
      });
    }
    summary.addEventListener("mouseover", (event) => {
      event.target.closest("details[open]");
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });
  } else {
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.addEventListener("change", () => {
      console.log("change");
    });

    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach(
      (button) =>
        button.addEventListener("click", this.onButtonClick.bind(this)),
      document.dispatchEvent(new CustomEvent("quantityUpdated")),
    );
    this.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        console.log("Enter key pressed! Input value");
        event.preventDefault();
        this.querySelector(".quantity__input").blur();
        this.blur();
      }
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    console.log("close");
    if (event === undefined) return;

    // turns icon from dropdown
    document
      .querySelector(".filter__button.active")
      ?.classList.remove("active");

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);
document.querySelectorAll(".link-menu").forEach((ele) => {
  ele.addEventListener("mouseenter", () => {
    document.querySelectorAll("details[open].mega-menu").forEach((ele) => {
      ele.removeAttribute("open");
    });
  });
});
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.contactDetailsMobile = document.querySelector(
      ".contact-details-wrapper__mobile",
    );

    // Set initial state based on aria-expanded attribute
    this.handleContactDetailVisibility.bind(this);

    // Add event listener for window resize
    window.addEventListener(
      "resize",
      this.handleContactDetailVisibility.bind(this),
    );
  }

  // Function to handle visibility of contact details based on viewport width
  handleContactDetailVisibility() {
    const isExpanded = this.summary.getAttribute("aria-expanded") === "true";
    const viewportWidth = window.innerWidth;

    if (viewportWidth >= 1120) {
      this.contactDetailsMobile.style.display = "none";
    } else {
      this.contactDetailsMobile.style.display = isExpanded ? "flex" : "none";
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    this.handleContactDetailVisibility();
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);

    this.handleContactDetailVisibility();
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initialSlides = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');
    this.infiniteScroll = false;
    if (this.slider.dataset.infiniteScroll == "true") {
      this.infiniteScroll = true;
    }
    // ON HOLD SLIDER DOTS
    // this.sliderDotWrapper = this.querySelector(".slider-dots")
    // if(this.sliderDotWrapper){
    // 	this.sliderDots = this.sliderDotWrapper.querySelectorAll('[id^="Slider-Dot-"]');
    // 	this.allSlides = this.querySelectorAll('[id^="Slide-"]');
    // 	if( this.sliderDots && this.sliderDots.length > 0){
    // 	this.activeIndex = 0
    // 	this.sliderDots.forEach(dot => {
    // 		dot.addEventListener("click", this.onDotClick.bind(this))
    // 	})
    // }
    // }

    this.scrollPos = this.slider.scrollLeft;
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener("touchstart", () => {
      this.elementAdded = true;
    });
    this.slider.addEventListener("touchend", () => {
      this.elementAdded = true;
    });
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.nextButton.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
    if (this.infiniteScroll) {
      this.slideObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Das Element ist im Viewport sichtbar, nichts zu tun.
          } else {
            const element = entry.target;
            this.handleElementLeftViewport(element);
            // Das Element ist außerhalb des Viewports nach links gegangen.
          }
        });
      });

      this.initSlideObservers();
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.round(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    if (this.infiniteScroll) {
      this.totalPages = this.sliderItemsToShow.length;
    }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage > this.totalPages && this.infiniteScroll) {
      let quotient = Math.floor(this.currentPage / this.totalPages);
      this.currentPage = this.currentPage % (this.totalPages * quotient);
      if (this.currentPage == 0) {
        this.currentPage = this.totalPages;
      }
    }
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    // ON HOLD SLIDER DOTS
    // if(this.sliderDotWrapper){
    // this.activeSlide = this.searchFirstVisibleSlide()
    // this.sliderDotWrapper.querySelector(".slider-dot.active").classList.remove("active")
    // this.activeDot = this.sliderDotWrapper.querySelector(`.slider-dot[data-index="${this.activeSlide.dataset.index}"]`)
    // this.activeDot.classList.add("active")
    // }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.forEach((button) => {
        button.setAttribute("disabled", "disabled");
      });
    } else {
      this.prevButton.forEach((button) => {
        button.removeAttribute("disabled");
      });
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        -5,
      ) &&
      !this.infiniteScroll
    ) {
      this.nextButton.forEach((button) => {
        button.setAttribute("disabled", "disabled");
      });
    } else {
      this.nextButton.forEach((button) => {
        button.removeAttribute("disabled");
      });
    }
  }
  searchFirstVisibleSlide() {
    for (const slide of this.slider.querySelectorAll('[id^="Slide-"]')) {
      let isVisible = this.isSlideVisible(slide);
      if (isVisible) {
        return slide;
      }
    }
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.elementAdded = true;
    const step = event.currentTarget.dataset.step || 1;

    const isNext = event.currentTarget.name === "next";

    this.slideScrollPosition = isNext
      ? this.slider.scrollLeft + step * this.sliderItemOffset
      : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
  // ON HOLD SLIDER DOTS
  // onDotClick(event){
  // 	this.elementAdded = true
  // 	this.dotclicked = false
  // 	this.stopUpdate = true
  // 	let dot = event.target.closest(".slider-dot") || event.target
  // 	let index = dot.dataset.index
  // 	if(dot.classList.contains("active")){
  // 		return;
  // 	}
  // 	else{
  // 	Number(index)
  // 	if(this.activeIndex < index){

  // 		let difference = index - this.activeIndex
  // 		let isNext = true

  // 			// this.scrollOneSlide(isNext)
  // 			this.slider.scrollLeft = this.slider.scrollLeft + difference * this.sliderItemOffset

  // 	}
  // 	else{

  // 	}
  // 	this.activeIndex = index
  // 	this.activeDot.classList.remove("active")
  // 	dot.classList.add("active")
  // 	this.activeDot = dot
  // 	console.log("index to scroll" , index)
  // 	// this.dotclicked = true
  // 	// this.stopUpdate = false
  // 	}

  // }
  isFirstSlideVisible() {
    return this.slider.scrollLeft === 0;
  }

  isLastSlideVisible() {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft;
    return lastVisibleSlide >= this.slider.scrollWidth;
  }
  initSlideObservers() {
    // Füge alle Elemente in this.sliderItems zum Observer hinzu.
    this.sliderItems.forEach((item) => {
      this.slideObserver.observe(item);
    });
  }
  handleElementLeftViewport(element) {
    let addIndex = Number(element.dataset.index);
    let oldScrollLeft = this.slider.scrollLeft;
    let nextInRow = false;
    if (
      this.lastAddedIndex != addIndex &&
      (addIndex == this.lastAddedIndex + 1 ||
        (this.lastAddedIndex == this.initialSlides.length - 1 &&
          addIndex == 0) ||
        (addIndex == 0 && this.lastAddedIndex == undefined))
    ) {
      nextInRow = true;
    }
    if (nextInRow && this.elementAdded) {
      let addElement = Array.from(this.initialSlides)
        .find((element) => Number(element.dataset.index) == addIndex)
        .cloneNode(true);
      this.slider.scrollLeft = oldScrollLeft;
      this.slider.appendChild(addElement);
      this.slider.scrollLeft = oldScrollLeft;
      this.slideObserver.observe(addElement);
      this.slider.scrollLeft = oldScrollLeft;
      this.lastAddedIndex = addIndex;
      this.allSlides = this.querySelectorAll('[id^="Slide-"]');
      this.slideObserver.unobserve(element);
      console.log("index added", addIndex);
    }
  }

  scrollToActiveElement(activeElement) {
    if (activeElement) {
      const scrollPosition = activeElement.offsetLeft;
      this.slider.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      return;
    }

    // If on PDP (update-url enabled), navigate to the new variant URL for a full refresh
    if (this.dataset.updateUrl === "true" && this.currentVariant) {
      window.location.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      return;
    }

    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateSkuDisplay();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
  }

  updateSkuDisplay() {
    const cardSkuDisplay =
      this.closest(".card__content")?.querySelector(".card__sku");
    if (this.currentVariant.sku && cardSkuDisplay) {
      cardSkuDisplay.innerHTML = this.currentVariant.sku;
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    console.log("this.currentVariant", this.currentVariant);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    console.log();
    let productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    if (productForms.length == 0) {
      productForms = [this.closest("form")];
    }
    console.log("this.productForms", productForms, this.closest("form"));

    productForms.forEach((productForm) => {
      let input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const fetchUrl = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
      this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
    }`;
    console.log(
      "[VariantSelects] Fetching:",
      fetchUrl,
      "| Variant ID:",
      requestedVariantId,
    );

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const sId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(`price-${sId}`);

        console.log(
          "[VariantSelects] Price source innerHTML:",
          source ? source.innerHTML.substring(0, 200) : "NULL",
        );
        console.log(
          "[VariantSelects] Price dest innerHTML (before):",
          destination ? destination.innerHTML.substring(0, 200) : "NULL",
        );

        const skuSource = html.getElementById(`Sku-${sId}`);
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const skuSourceMobile = html.getElementById(`Sku-${sId}--mobile`);
        const skuDestinationMobile = document.getElementById(
          `Sku-${this.dataset.section}--mobile`,
        );
        const inventorySource = html.getElementById(`Inventory-${sId}`);
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        const volumePricingSource = html.getElementById(`Volume-${sId}`);

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${sId}`);

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        );
        const availabilitySource = html.getElementById(`Availability-${sId}`);
        const availabilityDestination = document.getElementById(
          `Availability-${sId}`,
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          console.log(
            "[VariantSelects] Price updated. New innerHTML:",
            destination.innerHTML.substring(0, 200),
          );
        } else {
          console.warn(
            "[VariantSelects] Price update failed - source:",
            !!source,
            "destination:",
            !!destination,
          );
          // Fallback: try to find the price wrapper by class within the product-info container
          const fallbackSource = html.querySelector(
            ".product-info__price-wrapper",
          );
          const fallbackDest = document.querySelector(
            ".product-info__price-wrapper",
          );
          if (fallbackSource && fallbackDest) {
            fallbackDest.innerHTML = fallbackSource.innerHTML;
            console.log("[VariantSelects] Price updated via fallback");
          }
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
          skuDestinationMobile.innerHTML = skuSourceMobile.innerHTML;
          skuDestinationMobile.classList.toggle(
            "visibility-hidden",
            skuSourceMobile.classList.contains("visibility-hidden"),
          );
        }
        if (availabilitySource && availabilityDestination) {
          availabilityDestination.innerHTML = availabilitySource.innerHTML;
        }
        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "visibility-hidden",
            pricePerItemSource.classList.contains("visibility-hidden"),
          );
        }

        // Update quantity form (min, max, step, value) for the new variant
        const quantityFormSource = html.getElementById(
          `Quantity-Form-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const quantityFormDestination = document.getElementById(
          `Quantity-Form-${this.dataset.section}`,
        );
        if (quantityFormSource && quantityFormDestination) {
          const sourceInput =
            quantityFormSource.querySelector(".quantity__input");
          const destInput =
            quantityFormDestination.querySelector(".quantity__input");
          if (sourceInput && destInput) {
            destInput.setAttribute(
              "data-min",
              sourceInput.getAttribute("data-min") || "",
            );
            destInput.setAttribute(
              "min",
              sourceInput.getAttribute("min") || "",
            );
            if (sourceInput.hasAttribute("data-max")) {
              destInput.setAttribute(
                "data-max",
                sourceInput.getAttribute("data-max"),
              );
              destInput.setAttribute("max", sourceInput.getAttribute("max"));
            } else {
              destInput.removeAttribute("data-max");
              destInput.removeAttribute("max");
            }
            destInput.setAttribute(
              "step",
              sourceInput.getAttribute("step") || "1",
            );
            destInput.value = sourceInput.getAttribute("min") || "1";
            destInput.setAttribute(
              "data-cart-quantity",
              sourceInput.getAttribute("data-cart-quantity") || "0",
            );
          }
          // Update inventory_quantity hidden input
          const sourceInvInput = quantityFormSource.querySelector(
            'input[name="inventory_quantity"]',
          );
          const destInvInput = quantityFormDestination.querySelector(
            'input[name="inventory_quantity"]',
          );
          if (sourceInvInput && destInvInput) {
            destInvInput.value = sourceInvInput.value;
          }
          // Update not-available class on the quantity form
          quantityFormDestination.classList.toggle(
            "not-available",
            quantityFormSource.classList.contains("not-available"),
          );
          // Re-validate quantity button states
          const quantityElement =
            quantityFormDestination.querySelector("quantity-input");
          if (
            quantityElement &&
            typeof quantityElement.validateQtyRules === "function"
          ) {
            quantityElement.validateQtyRules();
          }
        }

        // Update buy buttons (swap between add-to-cart and back-in-stock)
        const buyButtonsSource = html.getElementById(`BuyButtons-${sId}`);
        const buyButtonsDestination = document.getElementById(
          `BuyButtons-${this.dataset.section}`,
        );
        if (buyButtonsSource && buyButtonsDestination) {
          buyButtonsDestination.innerHTML = buyButtonsSource.innerHTML;
          console.log("[VariantSelects] Buy buttons updated");
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((error) => {
        console.error("[VariantSelects] renderProductInfo fetch error:", error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    if (pricePerItem) pricePerItem.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class customVideoWrapper extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");
    this.video.addEventListener("play", this.start.bind(this));
    this.video.addEventListener("pause", this.stop.bind(this));
    this.video.addEventListener("ended", this.stop.bind(this));
  }
  start() {
    this.classList.add("playing");
  }
  stop() {
    this.classList.remove("playing");
  }
}
customElements.define("custom-video", customVideoWrapper);

class klaviyoForm extends HTMLElement {
  constructor() {
    super();
    this.list_id = this.dataset.listId;
    this.email_input = this.querySelector("input[type='email']");
    this.submit_button = this.querySelector("[id^='submit--klaviyo']");
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.submit.bind(this));
  }
  submit(event) {
    event.preventDefault();
    let request = {
      email: this.email_input.value,
      list_id: this.list_id,
      store: "B2B",
    };
    let requestOptions = {
      method: "post",
      body: JSON.stringify(request),
    };
    this.classList.add("submited");
    fetch("https://eo43cswfbh852sz.m.pipedream.net", requestOptions)
      .then((response) => console.log(response.text()))
      .catch((error) => console.log("error", error));
  }
}

customElements.define("klaviyo-form", klaviyoForm);
// class klaviyoBackInStockForm_B2B extends klaviyoForm{
// 	constructor(){
// 		super()
// 		this.variant_id = this.dataset.variantId
//     this.popupButton = this.querySelector("open-popup")
// 	}

//   fetchBIS() {
//     const id = `$shopify:::$default:::${this.variant_id}`
//     const payload = {
//       "data": {
//         "type": "back-in-stock-subscription",
//         "attributes": {
//           "profile": {
//             "data": {
//                 "type": "profile",
//                 "attributes": {
//                     "email": this.email_input.value,
//                 }
//             }
//           },
//           "channels": ["EMAIL"],
//         },
//         "relationships": {
//           "variant": {
//             "data": {
//               "type": "catalog-variant",
//               "id": id
//             }
//           }
//         }
//       }
//     }

//     let requestOptions = {
//         method: 'POST',
//         headers: {
//           "Content-Type": "application/json",
//           "revision":"2024-06-15"
//         },
//         body: JSON.stringify(payload),
//     };

//     fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UQqbJ7",requestOptions)
//         .then(result => console.log('result', result))
//         .catch(error => console.log('error', error));
//   }

// 	submit(event){
// 		event.preventDefault()
//     this.fetchBIS();
//     this.submit_button.classList.add("active")
// 		let request = {
// 			email: this.email_input.value,
// 			variant_id: this.variant_id,
//       store: "B2B"
// 		}
// 		let requestOptions = {
// 			method: 'post',
// 			body: JSON.stringify(request),
// 		};
// 		this.email_input.disabled = true;
// 		this.classList.add("submited")
//     this.openAlert()
// 	  fetch("https://eoak6s7b0n5syoa.m.pipedream.net", requestOptions)
// 	  .then(response => {

//     }
// 	  )
// 	  .catch(error => console.log('error', error));
// 	}
//   openAlert(){
//     this.popupButton.open()
//   }
// }
// if(!customElements.get("klaviyo-back-in-stock")){
// 	customElements.define("klaviyo-back-in-stock", klaviyoBackInStockForm_B2B)
// }

class informationPopup extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector(".information-popup-icon--wrapper");
    this.icon.addEventListener("mouseover", this.open.bind(this));
    this.icon.addEventListener("mouseleave", this.close.bind(this));
    this.icon.addEventListener("click", this.open.bind(this));
    this.closeButton = this.querySelector(".information-popup--close");
    this.closeButton.addEventListener("click", this.close.bind(this));
    if (
      this.querySelector(".information-popup--background a") ||
      this.querySelector(".information-popup--background button")
    ) {
      this.has_clickable_element = true;
      this.classList.add("clickable");
    } else {
      this.has_clickable_element = false;
    }
  }
  open(event) {
    if (
      event.type == "click" ||
      (event.type == "mouseover" && window.innerWidth > 990)
    ) {
      this.setAttribute("open", "");
    }
  }
  close(event) {
    if (
      event.type == "click" ||
      (event.type == "mouseleave" &&
        window.innerWidth > 990 &&
        !this.has_clickable_element)
    ) {
      this.removeAttribute("open");
    }
  }
}
if (!customElements.get("information-popup")) {
  customElements.define("information-popup", informationPopup);
}
class OpenPopup extends HTMLElement {
  constructor() {
    super();
    this.popup = document.querySelector(`#${this.dataset.popup}`);
    this.addEventListener("click", this.open.bind(this));
    this.controller = this.popup.closest("popup-controller");
  }
  open(event) {
    document.querySelector("body").classList.add("lock-position");
    this.controller?.classList.remove("hidden");
    this.popup.classList.remove("hidden");
    if (this.popup.getAttribute("type") == "alert") {
      let closeTimeMillies = 3000;
      setTimeout(() => {
        this.popup.classList.add("open");
      }, 100);

      if (this.popup.getAttribute("close-time")) {
        closeTimeMillies = Number(this.popup.getAttribute("close-time"));
      }
      setTimeout(() => {
        this.controller.close();
      }, closeTimeMillies);
    }
  }
}
if (!customElements.get("open-popup")) {
  customElements.define("open-popup", OpenPopup);
}

class closePopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.close.bind(this));
  }
  close() {
    console.log("close");
    this.closest(".popup-controller").close();
  }
}
if (!customElements.get("close-popup")) {
  customElements.define("close-popup", closePopup);
}

class popupController extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => this.close(event));
  }
  close(event) {
    if (event && event.target.closest(".popup")) {
      return;
    } else {
      this.classList.add("hidden");
      // this.querySelector(".product-popup-wrapper:not(.hidden)").classList.add("hidden")
      if (this.getAttribute("type") == "alert") {
        this.querySelector(".popup:not(.hidden)")?.classList.remove("open");
      }
      this.querySelector(".popup:not(.hidden)")?.classList.add("hidden");
      document.querySelector("body").classList.remove("lock-position");
    }
  }
}
if (!customElements.get("popup-controller")) {
  customElements.define("popup-controller", popupController);
}

class accordionSection extends HTMLElement {
  constructor() {
    super();
    // add eventlistener to open/close accordions
    this.accordions = this.querySelectorAll(
      ".accordion_section_wrapper .accordion_title",
    );
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", () => {
        if (accordion.parentElement.classList.contains("active")) {
          accordion.parentElement.classList.remove("active");
          accordion.parentElement.querySelector(".accordion_content").style =
            `max-height: 0`;
        } else {
          // set height of video element so show full video
          this.videoHeight = this.querySelector("deferred-media");
          accordion.parentElement.querySelector(".accordion_content").style =
            `max-height: ${this.videoHeight.offsetHeight + 2}px`;
          accordion.parentElement.classList.add("active");
        }
      });
    });
  }
}
customElements.define("accordion-section", accordionSection);

class klaviyoBackInStockForm extends klaviyoForm {
  constructor() {
    super();
    this.variant_input = this.querySelector("input[name='variant_id']");
    this.email_input = this.querySelector(".klaviyo-bis-email");
    this.submit_button = this.querySelector(".klaviyo-bis-submit");
  }
  submit(event) {
    event.preventDefault();
    // this.submit_button.classList.add("active")
    let request = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                // id is optional, only include if you have it
                email: this.email_input.value,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${this.variant_input.value}`,
            },
          },
        },
      },
    };
    let requestOptions = {
      method: "post",
      headers: {
        accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json",
        revision: "2025-04-15",
      },
      body: JSON.stringify(request),
    };
    this.email_input.disabled = true;
    this.submit_button.disabled = true;
    this.classList.add("submited");

    fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${window.klaviyo.companyId}`,
      requestOptions,
    )
      .then((response) => {
        setTimeout(() => {
          const srFeedback = this.querySelector("bis-sr-feedback");
          if (srFeedback) {
            srFeedback.textContent =
              "You have successfully subscribed to back-in-stock notifications.";
          }
        }, 1000);
      })
      .catch((error) => console.log("error", error));
  }
}
if (!customElements.get("klaviyo-back-in-stock")) {
  customElements.define("klaviyo-back-in-stock", klaviyoBackInStockForm);
}

class klaviyoBackInStockOpen extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    console.log(this.dataset.productTitle, this.dataset.variantId);
    this.product_title = this.dataset.productTitle;
    this.variant_id = this.dataset.variantId;
    this.button = this.querySelector("button");
    if (this.button) {
      this.button.addEventListener("click", this.openForm.bind(this));
    }
  }
  openForm() {
    const popup = document.getElementById("back-in-stock-popup");
    if (popup) {
      const variant_input = popup.querySelector("input[name='variant_id']");
      if (!variant_input) return;
      variant_input.value = this.variant_id;
      const product_title = popup.querySelector(".product-title");
      if (!product_title) return;
      product_title.textContent = this.product_title;
      popup.show();
    }
  }
}
if (!customElements.get("klaviyo-back-in-stock-open")) {
  customElements.define("klaviyo-back-in-stock-open", klaviyoBackInStockOpen);
}

class klaviyoBackInStockPopup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("klaviyo-back-in-stock");
    this.addEventListener("click", this.handleOverlayClick.bind(this));
    this.closeButton = this.querySelector(".close-button");
    this.closeButton?.addEventListener("click", () => {
      this.hide();
    });
  }

  show() {
    this.setAttribute("aria-hidden", "false");
    this.form.classList.remove("submited");
    this.form.email_input.disabled = false;
    this.form.submit_button.disabled = false;
    // Set focus for accessibility
    if (this.form) {
      this.form.focus();
    } else {
      this.setAttribute("tabindex", "-1");
      this.focus();
    }
  }

  hide() {
    this.setAttribute("aria-hidden", "true");
  }
  handleOverlayClick(event) {
    if (!event.target.closest(".klaviyo-bis-popup-content")) {
      this.hide();
    }
  }
}

if (!customElements.get("klaviyo-back-in-stock-popup")) {
  customElements.define("klaviyo-back-in-stock-popup", klaviyoBackInStockPopup);
}
